import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

import ModalImage from "react-modal-image"
import reference from '../img/reference.jpg';
import reference2 from '../img/reference2.jpg';

export default function Content(props) {
  if (props.showMap) {
    return (
      <div className='px-lg-6 px-4 mb-3'>
        <p className='content-p'>{props.text}
        </p>
        <div className='d-flex justify-content-between flex-column flex-sm-row gap'>
          <div className='about-container cw-100'>
            {/* <h4>
              Idag är plåt ett väldigt vanligt, prisvärt och hållbart byggnadsmaterial.
            </h4> */}
            <p className='content-p'>
              Med mer än 30 års yrkeserfarenhet har vi hjälpt våra kunder stora som små.
              2017 startade vi LJ:s plåtslageri med målet att genom bra kundkontakt och bra samarbetspartners utföra
              högkvalitativa arbeten som vi kan stå för.
            </p>
          </div>
          <MapContainer className='map-container cw-100' center={[58.43051953563904, 15.61124951464885]} zoom={14} scrollWheelZoom={false}>
            <TileLayer
              attribution=''
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[58.43051953563904, 15.61124951464885]}>
              <Popup>
                LJ:s Plåtslageri
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
    )
  }
  else {
    return (
      <div className='px-lg-6 px-4'>
   {props.text.map((x, index) => (
  <div key={index}>
    <p className='content-p'>{x}</p>
    <br />
  </div>
))}
        <div className='d-flex justify-content-between flex-column flex-sm-row gap mb-3'>
          <div className='reference-image'>
            <ModalImage
              small={reference}
              large={reference}
              alt="referensbild"
            />
          </div>
          <div className='reference-image'>
            <ModalImage
              small={reference2}
              large={reference2}
              alt="referensbild"
            />
          </div>
        </div>
      </div>
    )
  }
}